<template>
    <v-card class="material-dialog">
        <v-card-title class="text-h5 card-text">
            Υλικά Προδέσμευσης
        </v-card-title>

        <v-card-text class="card-text">
            Τα υλικά μέσα από το αρχείο της Προδέσμευσης
        </v-card-text>
        <array-view  :items="prodesmeusiMaterials.building" :headers="headers" :totalPages="0" :page="1" :size="10" />
        <div class="materials">
            <div v-for="material in Object.keys(prodesmeusiMaterials.materials)" :key="material" class="material"><b>{{ prodesmeusiMaterials.materials[material] }}</b> x {{ material }}</div>
        </div>
    </v-card>
</template>

<script>
    import ArrayView from '@/components/ArrayView.vue'

    export default {
        components: { ArrayView },
        props: {
            prodesmeusiMaterials: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                headers: [
                    {
                        text: 'BEP Type',
                        align: 'start',
                        sortable: false,
                        value: 'bepType'
                    },
                    { text: 'BMO Type', value: 'bmoType' },
                    { text: 'Νεο BCP', value: 'newBcp' }
                ]
            }
        }
    }
</script>
<style scoped>

.card-text {
    color: var(--cards-and-tables-text-color) !important;
}

.materials {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
}

.material {
    margin: 0.8rem;
}

.download-icon {
    margin-left: 1rem;
}
</style>
